/* Policy pages (Knut 2026-10-09): /policies/shipping-policy, refund-policy, privacy-policy and terms-of-service. Shopify builds these pages
   (.shopify-policy__container > .shopify-policy__title + .shopify-policy__body); the theme can only style them (src/css/theme.css, «Policy pages») and add small
   enhancements like this one, loaded from layout/theme.liquid on request.page_type == 'policy'. It
   1. turns a bold label that opens a paragraph and is followed by a line break («Fraktvalg i kassen») into a small heading (.pp-label), and
   2. builds the table of contents «På denne siden» from the H3 headings (when there are at least three), with anchor links and the current section marked.
   Without JavaScript the page is the styled text without the table of contents. */
(function () {
  'use strict';
  var container = document.querySelector('.shopify-policy__container');
  var body = container && container.querySelector('.shopify-policy__body');
  if (!body) return;

  var strongs = body.querySelectorAll('p > strong:first-child');
  Array.prototype.forEach.call(strongs, function (s) {
    var next = s.nextSibling;
    var text = (s.textContent || '').trim();
    var before = s.previousSibling;
    if (before && before.nodeType === 3 && before.textContent.trim() !== '') return;
    if (!next || next.nodeType !== 1 || next.tagName !== 'BR') return;
    if (text.length < 3 || text.length > 70 || /[.!?]$/.test(text)) return;
    s.classList.add('pp-label');
  });

  var heads = Array.prototype.slice.call(body.querySelectorAll('h3'));
  if (heads.length < 3) return;

  var used = {};
  var strip = function (t) { return t.replace(/^[^\p{L}\p{N}]+/u, '').replace(/\s+/g, ' ').trim(); };
  var slug = function (t) {
    var s = t.toLowerCase().replace(/æ/g, 'ae').replace(/ø/g, 'o').replace(/å/g, 'a').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '') || 'seksjon';
    var base = s, n = 2;
    while (used[s]) { s = base + '-' + n++; }
    used[s] = true;
    return s;
  };

  var nav = document.createElement('nav');
  nav.className = 'pp-toc';
  nav.setAttribute('aria-label', 'På denne siden');
  var title = document.createElement('p');
  title.className = 'pp-toc__title';
  title.textContent = 'På denne siden';
  var list = document.createElement('ol');
  var links = [];
  heads.forEach(function (h) {
    var label = strip(h.textContent || '').replace(/^[""'\u201C\u201D\u00AB\u00BB]+|[""'\u201C\u201D\u00AB\u00BB]+$/g, '');
    if (!label) return;
    if (!h.id) h.id = slug(label);
    var li = document.createElement('li');
    var a = document.createElement('a');
    a.href = '#' + h.id;
    a.textContent = label;
    li.appendChild(a);
    list.appendChild(li);
    links.push({ a: a, h: h });
  });
  if (links.length < 3) return;
  nav.appendChild(title);
  nav.appendChild(list);
  container.classList.add('pp-has-toc');
  container.insertBefore(nav, body);

  var mark = function (current) {
    links.forEach(function (l) {
      if (l.h === current) l.a.setAttribute('aria-current', 'true');
      else l.a.removeAttribute('aria-current');
    });
  };
  mark(links[0].h);

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) mark(e.target); });
    }, { rootMargin: '-15% 0px -75% 0px' });
    links.forEach(function (l) { io.observe(l.h); });
  }
})();
